
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';

const PrivateRoute = () => {
  const { user } = useAuth();

  // Se o usuário estiver autenticado, renderiza o componente filho (Outlet)
  // Caso contrário, redireciona para a página de login
  return user ? <Outlet /> : <Navigate to="/authentication/sign-in" />;
};

export default PrivateRoute;
